import React, { useEffect, useState } from 'react';
import history from 'utils/history';
import api from 'utils/api';
import logoLogin from 'images/logo_login.svg';
import 'containers/SignUp/index.css';

function ReferrerVerifyEmail() {
	const [error, setError] = useState(null);
	const [verifying, setVerifying] = useState(true);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const token = params.get('token');

		if (!token) {
			setError('Missing verification token.');
			setVerifying(false);
			return;
		}

		api
			.get('/referrer/verify-email', { params: { token } })
			.then(() => {
				history.push('/referrer/signin?verified=true');
			})
			.catch((err) => {
				const message =
					err.response?.data?.message ||
					'Verification failed. Please try again or contact support.';
				setError(message);
				setVerifying(false);
			});
	}, []);

	return (
		<div className="container-fluid p-0 d-flex h-100vh bg-white">
			<div className="col d-flex align-self-center flex-column px-xl-5">
				<div className="d-flex justify-content-center mb-4">
					<img src={logoLogin} alt="" />
				</div>
				{verifying ? (
					<div className="text-center font-15">Verifying your email...</div>
				) : error ? (
					<div className="text-center">
						<div className="error-font mb-3">{error}</div>
						<span
							className="link-color font-weight-bold hand"
							onClick={() => history.push('/referrer/signin')}
						>
							Go to Sign In
						</span>
					</div>
				) : null}
			</div>
		</div>
	);
}

export default ReferrerVerifyEmail;
